
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import SwitchedContainer from './containers/SwitchedContainer.vue';

@Component({
    components: {
        SwitchedContainer,
    },
})
export default class Switched extends Vue {
    @Prop({ type: String, required: true })
    label!: string;

    @Prop({ type: String, default: '' })
    description!: string;

    @Prop({ type: Boolean, required: true })
    value!: boolean;

    @Prop({ type: Boolean, default: false })
    grouped!: boolean;

    currentValue = null as unknown as boolean;

    created() {
        this.currentValue = this.value;
    }

    @Watch('currentValue')
    onCurrentValueChange() {
        if (this.currentValue !== this.value) {
            this.$emit('input', this.currentValue);
        }
    }

    @Watch('value')
    onValueChange() {
        if (this.currentValue !== this.value) {
            this.currentValue = this.value;
        }
    }
}
